const HOSTNAME_ENV_MAP: Array<[RegExp, string, string]> = [
  [/\btst\b|\btest\b/, 'tst', 'awn'],
  [/\bsbx\b/, 'sbx', 'aws'],
  [/\bqap\b/, 'qap', 'awn'],
  [/\bqua\b/, 'qua', 'awn'],
  [/\bprd\b|\bprod\b/, 'prd', 'awp'],
];

function resolveBaseUrl(): string | null {
  const { hostname } = window.location;
  for (const [pattern, envCode, domain] of HOSTNAME_ENV_MAP) {
    if (pattern.test(hostname)) {
      return `https://av-api-platform-${envCode}.applicationplatform.${domain}.availity.com`;
    }
  }
  return null;
}

export const getCurrentEnv = (): string | null => {
  const { hostname } = window.location;
  for (const [pattern, envCode] of HOSTNAME_ENV_MAP) {
    if (pattern.test(hostname)) {
      return envCode;
    }
  }
  return null;
};

const base = resolveBaseUrl();

export const getPortalBackendBaseUrl = () => (base ? `${base}/portal-backend/api` : 'http://localhost:8000/api');

export const getUnifiedGatewayBaseUrl = () =>
  base ? `${base}/unified-gateway` : 'http://localhost:8001/unified-gateway';
